import { StorageService } from '@empathy/storage-service';
import { container } from '../../../container';
import { DEPENDENCIES, STORAGE } from '../../../container/dependencies.const';
import { EmpathyXConfig } from '../../../models';
import { GETTERS_KEYS } from '../../store.const';
import { TRACKING_ACTIONS_KEYS } from '../tracking.const';
import { TrackingAction, TrackingContext } from '../tracking.interfaces';

export class SaveItemToLocalStorageWithUrlAction implements TrackingAction {
  private storageService: StorageService;

  actions = {
    [TRACKING_ACTIONS_KEYS.saveItemToLocalStorageWithURL]: ({ rootGetters }: TrackingContext,
      item: { url: string }) => {
      this.storageService = container.getNamed<StorageService>(DEPENDENCIES.StorageService, STORAGE.Local);
      const { tracking }: EmpathyXConfig = rootGetters[GETTERS_KEYS.config.config];
      const ttlInMS = tracking.click.storage.urlTTLInMs;
      this.storageService.setItem(item.url, item, ttlInMS);
    }
  };
}
